var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"watermarkContainer",staticClass:"watermark-container"},_vm._l((_vm.watermarkArray),function(item,index){return _c('div',{key:index,staticClass:"watermark-text",style:(_vm.getWatermarkItemStyle(index))},[_vm._v(" "+_vm._s(_vm.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }